import { Component, OnInit, Output, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AccountService } from 'src/modules/features/setting/services';
import { AuthenticationService } from 'src/modules/core/services';
import { ConfirmModal, CommonServices, SharedValidators, TwoFactorModal } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { NotificationService } from '../../services';
@Component({
	selector: 'app-notification-config',
	templateUrl: './configuration.component.html',
	styleUrls: [ './account-security.component.scss' ]
})
export class ConfigurationComponent implements OnInit {
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt;
	accountForm: FormGroup;
	@Input() app: any;
	@Input() user: any;

	organization: any;
	pending: boolean;
	error: any;
	success: any;
	image = 'assets/avatar/1.jpg';
	baseUrl: string = environment.API_SERVER;
	configs: Array<any> = [];

	constructor(
		private commonSvc: CommonServices,
		private authService: AuthenticationService,
		private modalService: SuiModalService,
		private location: Location,
		private notificationSvc: NotificationService,
		private builder: FormBuilder
	) {
		this.user = JSON.parse(window.localStorage.getItem('user'));
		this.accountForm = this.builder.group(
			{
				oldPassword: [ '', Validators.required ],
				newPassword: [ '' ],
				password: [ '', [ Validators.required, SharedValidators.strongPassword ] ],
				confirmPassword: [ '', [ Validators.required, SharedValidators.strongPassword ] ]
			},
			{ validator: SharedValidators.matchingPasswords('password', 'confirmPassword') }
		);
	}

	getApplicationConfig() {
		this.pending = true;
		this.notificationSvc
			.getUserApplication({
				applicationId: this.app['applicationId'],
				appUserId: this.user['appUserId']
			})
			.subscribe(
				(res: any) => {
					this.pending = false;
					this.configs = res.map((config) => {
						return { ...config, appConfigValue: config.appConfigValue == 'true' ? true : false };
					});
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	updateApplicationConfig(event, config) {
		this.pending = true;
		this.notificationSvc
			.updateAppConfig({
				applicationId: this.app['applicationId'],
				configId: config['appConfigId'],
				appUserId: this.user['appUserId'],
				params: { value: event }
			})
			.subscribe(
				(res) => {
					this.pending = false;
					// this.configs = res
					this.success = 'Config notification updated successfully';
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
	}

	toggle(event, config) {
		this.modalService
			.open(
				new ConfirmModal(
					'Email Notication?',
					`Are you sure you want to ${event == true ? 'enable' : 'disable'} notification for this config?`,
					ModalSize.Tiny
				)
			)
			.onApprove(() => {
				this.updateApplicationConfig(event, config);
			})
			.onDeny(() => {});
	}
	isFieldValid(field: string) {
		return (
			(!this.accountForm.get(field).valid && this.accountForm.get(field).touched) ||
			(this.accountForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	goBack() {
		this.location.back();
	}
	ngOnInit(): void {
		this.getApplicationConfig();
	}
}
